import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from '../utils/utility';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'dhmRemain'
})
export class DayHourMinutesRemainPipe implements PipeTransform {
  constructor(private translate: TranslateService) {
  }
  transform(value: any): string {
    if (isNaN(value) || value < 0) return '';
    let x = Utility.parseSecondsToDHMS(value);
    let result = '';

    if (x.days) {
      result = x.days + this.translate.instant('day');
    }
    if (x.hours) {
      result += (x.days ? this.translate.instant(' و ') : '') + x.hours + this.translate.instant('hour')
    }
    if (x.minutes) {
      result += (x.hours ? this.translate.instant(' و ') : '') + x.minutes + this.translate.instant('minute');
    }
    return result;
  }

}
